<template>
  <div>
    <div class="case_div">
      <img class="home_banner" src="../../../static/img/介绍顶部图.jpg" />
      <div class="div_top_title">
        <p>以创新服务为动力·以服务质量求发展</p>
        <p class="p_title_sub">
          Drive By Innovative Service And Seek Development With Service Quality
        </p>
      </div>
    </div>
    <div>
      <div class="bottommenu">
        <ul class="nav nav-tabs nav-justified nav_style" id="leftNav">
          <li role="presentation">
            <a class="tab_item" @click="navto('/AboutUs/CompanyProfile')"
              >公司介绍</a
            >
          </li>
          <li role="presentation">
            <a class="tab_item" @click="navto('/AboutUs/Managerment')"
              >六大管理体系</a
            >
          </li>
          <li role="presentation">
            <a class="tab_item" @click="navto('/AboutUs/Operation')"
              >六大操作流程</a
            >
          </li>
          <li role="presentation">
            <a class="tab_item" @click="navto('/AboutUs/Serving')"
              >四大供餐模式</a
            >
          </li>
          <li role="presentation">
            <a class="tab_item" @click="navto('/News/News')">新闻动态</a>
          </li>
        </ul>
      </div>
      <router-view :key="$route.fullpath"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      Navpath: "/AboutUs/CompanyProfile",
    };
  },
  mounted() {
    this.Init();
  },
  destroyed() {},
  deactivated() {
    this.$destroy();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  methods: {
    Init() {},
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.$router.push(path);
      this.setActive();
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.navto(this.Navpath);
    },
    setActive() {
      $("#leftNav li").click(function (e) {
        $("#leftNav li").removeClass("active");
        $(this).addClass("active");
      });
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum1.start();
        },
        {
          offset: "80%",
        }
      );
      $(".mynum").waypoint(
        () => {
          this.$refs.mynum.start();
        },
        {
          offset: "80%",
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.case_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  height: 30vw;
  object-fit: cover;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.bottommenu {
  background-color: var(--textBlue) !important;
}

.el-menu-demo {
  margin-top: 3px;
}

.tab_item {
  color: #fff;
  height: 6rem;
  line-height: 3.5rem;
}

.tab_item:hover {
  color: var(--textBlue);
  background-color: #fff;
  border: 1px solid #fff;
}

.nav-tabs.nav-justified>.active>a, .nav-tabs.nav-justified>.active>a:focus, .nav-tabs.nav-justified>.active>a:hover {
  color: var(--textBlue);
  background-color: #fff;
  border: 1px solid #fff;
}

// .nav-tabs>li{
// margin:0;
// }
.nav-tabs.nav-justified>li>a {
  border-radius: 0;
  border-bottom: 0;
}

.nav_style {
  width: 60%;
  margin: auto;
}

.cover_div {
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 0);
  top: 0;
  left: 0;
}

.div_top_title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: white;
  font-size: 5rem;
  font-family: regular;

  .p_title_sub {
    font-size: 2rem;
    font-family: regular;
    margin: 0 1rem;
  }

  .litter_line_top {
    margin: auto;
    background-color: white;
    height: 1px;
    width: 20%;
  }
}

@media (max-width: 800px) {
  .div_top_title {
    font-size: 2rem;

    .p_title_sub {
      font-size: 1rem;
    }
  }
}
</style>

